import React, { useEffect, useState } from 'react';
import { Divider, Input, Placeholder } from 'semantic-ui-react';

import { Typography } from 'src/components/coreUI';
import dayjs from 'src/libs/dayjs';
import { formatPrice } from 'src/utils/helper';
import { useURLState } from 'src/hooks';
import { PaymentProcessParams } from 'src/thunks/payment';
import { useAppDispatch } from 'src/store';
import { validateCouponId, ValidCoupon } from 'src/thunks/coupon';
import { isRejected } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'src/constants/app';

const CourseInfo: React.FC<
  Partial<Model.Class> & {
    amount?: number;
    created?: number;
    isExtension?: boolean;
    expired_date?: string;
  }
> = ({ name, amount, created, expired_date, prices, isExtension }) => {
  const [{ cp_id, pr_id }] = useURLState<PaymentProcessParams>({});
  const dispatch = useAppDispatch();
  const [validCoupon, setValidCoupon] = useState<ValidCoupon>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const price = prices?.find((p) => p.id === pr_id);

  useEffect(() => {
    if (cp_id) {
      setLoading(true);
      let promise = dispatch(
        validateCouponId({ coupon_id: cp_id, class_price_id: pr_id }),
      );

      promise.then((res) => {
        if (isRejected(res)) {
          navigate(PATH.NOT_FOUND);
        }
        setValidCoupon(res.payload as unknown as ValidCoupon);
        setLoading(false);
      });

      return () => {
        promise.abort();
      };
    }
  }, [cp_id]);

  return !loading && price && amount ? (
    <React.Fragment>
      <Typography.Header>Course Details</Typography.Header>
      <div className="d-flex-between">
        <div className="fw-bold fs-20 mb-4">
          {name} {isExtension ? 'Extension' : ''}
        </div>
        <div>x1</div>
      </div>
      <div className="text-gray">
        valid until{' '}
        {expired_date ||
          dayjs().add(price.limit_months, 'month').format('MM.DD.YYYY')}
      </div>

      {validCoupon && (
        <div className="my-36">
          <div className="fs-18 d-flex-between fw-bold mb-8">
            <span>COUPON CODE</span>
            <span className="fs-18 fw-bold text-primary">
              {validCoupon && validCoupon.amount_off
                ? formatPrice(validCoupon.discount_amount)
                : null}
              {validCoupon && validCoupon.percent_off
                ? `${validCoupon.percent_off}%`
                : null}
            </span>
          </div>
          <Input
            value={validCoupon.code}
            disabled
            placeholder="Coupon code"
            fluid
          />
        </div>
      )}

      <Divider />
      <Typography.Paragraph className="d-flex-between">
        Total (1 item){' '}
        <span className="fs-24 fw-bold text-primary">
          {formatPrice(amount)}
        </span>
      </Typography.Paragraph>
    </React.Fragment>
  ) : (
    <Placeholder>
      <Placeholder.Line />
      <Placeholder.Line />
      <Placeholder.Line />
      <Placeholder.Line />
    </Placeholder>
  );
};

export default CourseInfo;
